export const FETCHING_LIST_WAIT_HAPPY = '@@toyota/FETCHING_LIST_WAIT_HAPPY';
export const FETCHED_LIST_WAIT_HAPPY = '@@toyota/FETCHED_LIST_WAIT_HAPPY';
export const FETCHED_LIST_WAIT_HAPPY_FAILED = '@@toyota/FETCHED_LIST_WAIT_HAPPY_FAILED';

export const FETCHING_DETAIL_WAIT_HAPPY = '@@toyota/FETCHING_DETAIL_WAIT_HAPPY';
export const FETCHED_DETAIL_WAIT_HAPPY = '@@toyota/FETCHED_DETAIL_WAIT_HAPPY';
export const FETCHED_DETAIL_WAIT_HAPPY_FAILED = '@@toyota/FETCHED_DETAIL_WAIT_HAPPY_FAILED';

export const FETCHING_LIST_WEEK_WAIT_HAPPY = '@@toyota/FETCHING_LIST_WEEK_WAIT_HAPPY';
export const FETCHED_LIST_WEEK_WAIT_HAPPY = '@@toyota/FETCHED_LIST_WEEK_WAIT_HAPPY';
export const FETCHED_LIST_WEEK_WAIT_HAPPY_FAILED = '@@toyota/FETCHED_LIST_WEEK_WAIT_HAPPY_FAILED';

export const UPDATING_LIST_WEEK_WAIT_HAPPY = '@@toyota/UPDATING_LIST_WEEK_WAIT_HAPPY';
export const UPDATED_LIST_WEEK_WAIT_HAPPY = '@@toyota/UPDATED_LIST_WEEK_WAIT_HAPPY';
export const UPDATED_LIST_WEEK_WAIT_HAPPY_FAILED = '@@toyota/UPDATED_LIST_WEEK_WAIT_HAPPY_FAILED';

export const UPDATING_DEALER_WAIT_HAPPY = '@@toyota/UPDATING_DEALER_WAIT_HAPPY';
export const UPDATED_DEALER_WAIT_HAPPY = '@@toyota/UPDATED_DEALER_WAIT_HAPPY';
export const UPDATED_DEALER_WAIT_HAPPY_FAILED = '@@toyota/UPDATED_DEALER_WAIT_HAPPY_FAILED';

export const DOWNLOADING_WAIT_HAPPY = '@@toyota/DOWNLOADING_WAIT_HAPPY';
export const DOWNLOADED_WAIT_HAPPY = '@@toyota/DOWNLOADED_WAIT_HAPPY';
export const DOWNLOADED_WAIT_HAPPY_FAILED = '@@toyota/DOWNLOADED_WAIT_HAPPY_FAILED';

export const CLEAR_DOWNLOADED_WAIT_HAPPY = '@@toyota/CLEAR_DOWNLOADED_WAIT_HAPPY';
